module.exports = __webpack_public_path__ + "img/cbam-yzs.61a194ff.png";